export default __webpack_public_path__ + "static/media/recipes.614243ea.png";